import React from 'react';
import { IconButton } from '@mui/material';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import styled from 'styled-components';

const StyledUpDown = styled.div`
  display: flex;
  flex-direction: column;

  & .MuiIconButton-sizeSmall {
    padding: 0;
  }
`;

interface UpDownProps {
  onDown: () => void;
  onUp: () => void;
}

const UpDown: React.FC<UpDownProps> = ({ onUp, onDown, ...props }) => {
  return (
    <StyledUpDown {...props}>
      <IconButton aria-label="up" size="small" onClick={onUp}>
        <ArrowDropUp fontSize="small" />
      </IconButton>
      <IconButton aria-label="down" size="small" onClick={onDown}>
        <ArrowDropDown fontSize="small" />
      </IconButton>
    </StyledUpDown>
  );
};

export default UpDown;
